export interface Carrier {
  carrierId: string;
  carrierName: string;
}
